import { useMutation, UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { IFile } from "../../../types/api/file";
import { TResponse } from "../../../types/common";
import { deleteFile, saveFile } from "./callbacks";

export const useFileSave = (
  { onSuccess, onError }: {
    onSuccess?: (res: TResponse<IFile>) => void;
    onError?: (error: unknown) => void;
  }
  ,
  options: UseMutationOptions<TResponse<IFile>, unknown, FormData> = {}
): UseMutationResult<TResponse<IFile>, unknown, FormData> => {
  return useMutation<TResponse<IFile>, unknown, FormData>({
    mutationFn: async (data: FormData) => {
      const response = await saveFile(data);
      return response.data as TResponse<IFile>;
    },
    onSuccess: (res: any, ...rest) => {
      onSuccess?.(res);
    },
    onError: (error, ...rest) => {
      onError?.(error);
    },
    ...options
  });
};

export const useFileDelete = (
  { onSuccess, onError }: {
    onSuccess?: (res: TResponse<null>) => void;
    onError?: (error: unknown) => void;
  }
  ,
  options: UseMutationOptions<TResponse<null>, unknown, { url: string }> = {}
): UseMutationResult<TResponse<null>, unknown, { url: string }> => {
  return useMutation<TResponse<null>, unknown, { url: string }>({
    mutationFn: async (data: { url: string }) => {
      const response = await deleteFile(data);
      return response.data;
    },
    onSuccess: (res: any, ...rest) => {
      onSuccess?.(res);
      options?.onSuccess?.(res, ...rest);
    },
    onError: (error, ...rest) => {
      onError?.(error);
      options?.onError?.(error, ...rest);
    },
    ...options
  });
};